import * as React from "react";
import { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { updatePrioritiesTab } from "redux/slices/updateDataSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getApiCall, postApiCall } from "services/apiHelper";
import { baseUrl } from "config/config";
import { FroalaRichText } from "../../util/FroalaRichtext";
import { CommentKey, CommentSectionName } from "constant";
import { DapComment, saveDapCommentData } from "redux/slices/saveCommentSlice";
import { updateDapCommentData } from "redux/slices/updateDapCommentSlice";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));



export const PrioritiesEditForm = ({ mode = "edit" }) => {
  const dispatch = useAppDispatch();
  const assetPlanId = useAppSelector((state) => state.getAssetPlanId.assetPlanId);
  const prioritiesData = useAppSelector((state) => state.updateData?.prioritiesTab) || {
    assetManagement: "",
    assetPlanId: "",
    leasing: "",
    building: "",
    sustainability: "",
    social: "",
    other: "",
    breaksExpiries: "",
    regears: ""
  };


  useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await getApiCall(`${baseUrl}AssetPlan/GetPrioritiesDetailsByAssetID?assetPlanId=${assetPlanId}`);
      dispatch(updatePrioritiesTab(response as any));
    } catch (error) {
      console.error('Error:', error);
    }
  };
  
  if (assetPlanId) fetchData();
}, [assetPlanId, dispatch]);

   
  const handleInputChange = (field: string, value: string) => {
    dispatch(updatePrioritiesTab({
      ...prioritiesData,
      assetPlanId: assetPlanId,
      [field]: value
    }));
  };


  const comments = useAppSelector((state) => state.dapComments?.data).find(
    (x) => x.commentKey.toLowerCase() === CommentKey.PRIORITY.toLowerCase()
  );

  const handleCommentsChange = (newValue: string) => {
    const updatedcomment: DapComment = {
      id: comments ? comments.id : 0,
      commentKey: comments ? comments.commentKey : CommentKey.PRIORITY,
      commentText: newValue || "",
      sectionName: CommentSectionName.PRIORITY,
      assetPlanId: assetPlanId,
    };
    dispatch(updateDapCommentData(updatedcomment));
    dispatch(saveDapCommentData(updatedcomment));

  };

  return (
    <div>
      <div className="tab-heading text-center">
        <h3 className="heading">Priorities</h3>
      </div>

      <h3 className="text-left sub-heading">Key Objectives</h3>

      <Box sx={{ flexGrow: 1 }} className="summary-form m-20">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Item>
              <h3 className="text-left">Asset Management</h3>
              <div className="grid-item-box">
                <FroalaRichText
                  model={prioritiesData.assetManagement}
                  handlesModelChange={(model) => handleInputChange('assetManagement', model)}
                  placeholder={false}
                />
              </div>
            </Item>
          </Grid>

          <Grid item xs={12} md={4}>
            <Item>
              <h3 className="text-left">Leasing</h3>
              <div className="grid-item-box">
                <FroalaRichText
                  model={prioritiesData.leasing}
                  handlesModelChange={(model) => handleInputChange('leasing', model)}
                  placeholder={false}
                />
              </div>
            </Item>
          </Grid>

          <Grid item xs={12} md={4}>
            <Item>
              <h3 className="text-left">Building</h3>
              <div className="grid-item-box">
                <FroalaRichText
                  model={prioritiesData.building}
                  handlesModelChange={(model) => handleInputChange('building', model)}
                  placeholder={false}
                />
              </div>
            </Item>
          </Grid>

          <Grid item xs={12} md={4}>
            <Item>
              <h3 className="text-left">Sustainability</h3>
              <div className="grid-item-box">
                <FroalaRichText
                  model={prioritiesData.sustainability}
                  handlesModelChange={(model) => handleInputChange('sustainability', model)}
                  placeholder={false}
                />
              </div>
            </Item>
          </Grid>

          <Grid item xs={12} md={4}>
            <Item>
              <h3 className="text-left">Social</h3>
              <div className="grid-item-box">
                <FroalaRichText
                  model={prioritiesData.social}
                  handlesModelChange={(model) => handleInputChange('social', model)}
                  placeholder={false}
                />
              </div>
            </Item>
          </Grid>

          <Grid item xs={12} md={4}>
            <Item>
              <h3 className="text-left">Other</h3>
              <div className="grid-item-box">
                <FroalaRichText
                  model={prioritiesData.other}
                  handlesModelChange={(model) => handleInputChange('other', model)}
                  placeholder={false}
                />
              </div>
            </Item>
          </Grid>
        </Grid>
      </Box>

      <h3 className="text-left sub-heading">Leasing Summary</h3>

      <Box sx={{ flexGrow: 1 }} className="summary-form m-20">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Item>
              <h3 className="text-left">Breaks / Expiries</h3>
              <div className="grid-item-box">
                <FroalaRichText
                  model={prioritiesData.breaksExpiries}
                  handlesModelChange={(model) => handleInputChange('breaksExpiries', model)}
                  placeholder={false}
                />
              </div>
            </Item>
          </Grid>

          <Grid item xs={12} md={4}>
            <Item>
              <h3 className="text-left">Regears</h3>
              <div className="grid-item-box">
                <FroalaRichText
                  model={prioritiesData.regears}
                  handlesModelChange={(model) => handleInputChange('regears', model)}
                  placeholder={false}
                />
              </div>
            </Item>
          </Grid>
        </Grid>
      </Box>

         <form className="m-20 lease-form">
              <fieldset>
                <legend className="lease-title">Comments</legend>
      
                <FroalaRichText
                  model={comments?.commentText || ""}
                  handlesModelChange={handleCommentsChange}
                />
              </fieldset>
            </form>
    </div>
  );
};